<template>
	<div class="login">
		<h2>Logged Out</h2>
		<p>You are being Logged Out. You will shortly be redirected back to Livelines UK Jobs</p>
		<iframe src="http://chatapp/logout/sso" style="display:none;"/>
	</div>
</template>

<script>
import axios from 'axios';

export default {
	
	name: "LogoutPage",

	mounted() {
        this.logout();
        setTimeout(function () {
            location.href = "https://www.livelinesukjobs.co.uk";
        }, 5000);
	},

	methods: {

		logout: function() {
			localStorage.removeItem('user-token');
        },
        
    }
  
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h2 {
	font-family: 'Inter UI',sans-serif;
	font-weight: 600;
    text-align: left;
    margin-bottom: 0;
}

p {
	margin: 15px 0 30px;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.7;
    color: #bdbac2;
}

.form-group {
    margin-bottom: -5px;
}

.form-control {
    background: #f5f5f5;
    color: #bdbac2;
    border: none;
    font-size: 16px;
    font-weight: 500;
    border-radius: 6px;
}

.primary {
    display: inline-block;
    padding: 14px 0;
    width: 100%;
    background: #007bff;
    font-weight: 600;
    line-height: 1.7;
    color: #fff;
    text-align: center;
    border-radius: 6px;
	margin-top: 15px;
}

.prepend {
	margin-top: -84px;
}

a {
    color: #007bff;
}

</style>
